var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { attrs: { type: _vm.type || "button", disabled: _vm.disabled } },
    [
      _vm.loading
        ? _c("span", {
            staticClass: "spinner-border spinner-border-sm mr-2",
            attrs: { "aria-hidden": "true" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", [_vm._v(_vm._s(_vm.text))])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7013bd2a", { render: render, staticRenderFns: staticRenderFns })
  }
}